import React, { useEffect } from 'react';
import StyledTableAreaOrderAdmin from './TableAreaOrderAdmin.styles';
import Table from '../Table';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import Pagination from '../Pagination';
import { changeFilter } from '../../store/order/orderSlice';
import orderThunk from '../../store/order/orderThunk';
import { orderAdminTableHead } from '../../store/order/orderAdminTableHead';

type PropsType = {
  userId?: string;
};

const TableAreaOrderAdmin: React.FC<PropsType> = ({ userId }) => {
  const orderSlice = useAppSelector((state) => state.orderSlice);
  const dispatch = useAppDispatch();

  const onChangeFilter = (title: string, value: string | Date | null) => {
    dispatch(changeFilter({ title, value }));
  };

  const handleChangePage = (page: number) => {
    dispatch(changeFilter({ title: 'page', value: `${page}` }));
  };

  useEffect(() => {
    dispatch(changeFilter({ title: 'userId', value: userId ?? '' }));
    if (userId) {
      dispatch(changeFilter({ title: 'page', value: '1' }));
    }

    return () => {
      if (userId) {
        dispatch(changeFilter({ title: 'userId', value: '' }));
      }
    };
  }, [dispatch, userId]);

  useEffect(() => {
    if (userId && orderSlice.filter.userId !== userId) {
      return;
    }

    (async () => {
      try {
        await dispatch(orderThunk.getAdminOrders(orderSlice.filter)).unwrap();
      } catch (error) {
        console.error(error);
      }
    })();
  }, [dispatch, orderSlice.filter, userId]);

  return (
    <StyledTableAreaOrderAdmin>
      {
        orderSlice.addition.isLoading ? (
          <div className="styled-app__loader-mini" />
        ) : (
          <>
            <Table
              filter={orderSlice.filter}
              setFilter={onChangeFilter}
              mainArray={orderSlice.orders}
              tableHead={orderAdminTableHead}
            />
            {
              orderSlice?.options ? (
                <Pagination
                  currentPage={orderSlice?.options.page}
                  totalCount={orderSlice?.options.totalPages}
                  pageSize={orderSlice?.options.perPage}
                  onPageChange={handleChangePage}
                  countItems={orderSlice?.options.totalRecords}
                />
              ) : null
            }
          </>
        )
      }
    </StyledTableAreaOrderAdmin>
  );
};

export default TableAreaOrderAdmin;
